var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-holder d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.abr))])])
}
var staticRenderFns = []

export { render, staticRenderFns }